import React from 'react';
import ReactDOM from 'react-dom/client';
// Self-hosted fonts (same families/weights previously loaded from Google
// Fonts) so the UI renders identically offline.
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';
import '@fontsource/dm-sans/400.css';
import '@fontsource/dm-sans/500.css';
import '@fontsource/dm-sans/600.css';
import '@fontsource/dm-sans/400-italic.css';
import '@fontsource/jetbrains-mono/400.css';
import './styles/globals.css';
import './i18n';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { ChatContextProvider } from './contexts/ChatContextProvider';
import reportWebVitals from './lib/analytics/reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ChatContextProvider>
        <App />
      </ChatContextProvider>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();